import React from "react";
import { FormControl } from "react-bootstrap";
import { normalizeId } from "../helpers/utility";

const RadioInput = ({
  id,
  title,
  groupName = "",
  defaultChecked,
  onChange,
  value,
  showLabel = false,
  className = "",
  label = "",
  groupID = "",
  disabled = false,
}) => {
  const inputId =
    id || normalizeId(`${groupID || groupName}-${value || title}`);
  return (
    <div className={"d-inline-flex " + className}>
      <FormControl
        id={inputId}
        type="radio"
        name={groupName}
        style={styles.radio}
        defaultChecked={defaultChecked}
        onChange={onChange}
        value={value}
        disabled={disabled}
      />
      {showLabel && (
        <label htmlFor={inputId} className="ml-2 my-auto">
          {label || title}
        </label>
      )}
    </div>
  );
};

const styles = {
  radio: {
    height: 13,
    width: 13,
    margin: "auto",
  },
};

export default RadioInput;
